import React from 'react'
import { IoChevronForwardOutline } from 'react-icons/io5';
import { RxCross2 } from 'react-icons/rx';
import { NavLink, useNavigate } from 'react-router-dom';

const TabWithFillter = ({ filter, setFilter, ewayBillChecker, tabList, callBackTab, activeTab, billClick, dynamicClass, arrowIcon = false, invoiceBillRaiseClass, disabled = false, isCountShow = false, isActiveButton = false, rightButton, tabButtonName, section = "", showAmount = false }) => {
    const navigate = useNavigate();

    const changeActiveTab = async (event, value) => {
        event.preventDefault();
        callBackTab(value);
    };

    return (
        <>
            <div className={`contentHead ${dynamicClass || ""}`}>
                <ul className={`nav nav-tabs cstNew_tabs ${invoiceBillRaiseClass}`} id="addParty" role="tablist">
                    {tabList?.map((item, indx) => {
                        // const isWebSetting = section === "setting";
                        // const key = indx + (item?.title || item?.label);
                        // // For setting section, skip items where item.web !== 1
                        // if (isWebSetting && item?.web !== 1) return null;
                        const isActive = activeTab === item?.id;
                        return (
                            <li
                                className="nav-item _vhlTab_li"
                                role="presentation"
                                key={indx + (item?.title || item?.label)}
                            >
                                {/* {isWebSetting ? (
                                    <NavLink
                                        className={({ isActive }) =>
                                            `nav-link tabCst_btn _vhlTab_lst ${isActive ? "active" : ""}`
                                        }
                                        to={item?.link || "#"}
                                        disabled={disabled}
                                    >
                                        <span>{item?.label}</span>
                                        {isCountShow && (
                                            <div className="_nwRate">
                                                {item?.data != null ? item.data.toFixed(2) : 0}
                                            </div>
                                        )}
                                        {item?.count !== undefined && (
                                            <span className="_counts">{item.count}</span>
                                        )}
                                        {arrowIcon && (
                                            <div>
                                                <IoChevronForwardOutline />
                                            </div>
                                        )}
                                    </NavLink>
                                ) : ( */}
                                <button
                                    className={`nav-link tabCst_btn _vhlTab_lst ${isActive ? "active" : ""}`}
                                    type="button"
                                    aria-selected={isActive}
                                    onClick={(e) => changeActiveTab(e, item?.id)}
                                    disabled={disabled}
                                >
                                    {!ewayBillChecker ? <span className='__mnLab_title'>{item?.title}</span> : <></>}
                                    {/* {isCountShow && (
                                        <div className="_nwRate">
                                            {item?.data != null ? item.data.toFixed(2) : 0}
                                        </div>
                                    )}
                                    {item?.count !== undefined && (
                                        <span className="_counts">{item.count}</span>
                                    )}
                                    {showAmount ? <span className='__mnLab_amount'> Amount &#x20B9; {item?.amount}</span> : <></>}
                                    {ewayBillChecker ? <span className='mt-1'>{item?.title}</span> : <></>}
                                    {arrowIcon && (
                                        <div>
                                            <IoChevronForwardOutline />
                                        </div>
                                    )} */}
                                </button>
                                {/* )} */}
                            </li>
                        );
                    })}
                    {/* {isActiveButton ? <div className='_rSideBtn' style={{ marginLeft: 'auto' }}><button className='_addComm_btn' onClick={(e) => rightButton(e)}> {tabButtonName}</button></div> : <></>} */}
                </ul>

                <div className='__filtsTb_flex'>
                    {filter.status !== 2 ? <div className='_allFilts_fxs'>
                        <div className='_inpW_search _lrl_inpSrch '>
                            <svg
                                className="srcIcon"
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                            >
                                <path
                                    opacity="0.2"
                                    d="M17.347 16.3507L12.7293 11.733C13.8389 10.4008 14.3923 8.69214 14.2742 6.96238C14.1562 5.23263 13.3757 3.61498 12.0954 2.44596C10.815 1.27695 9.13319 0.64656 7.39985 0.685944C5.66652 0.725329 4.0151 1.43145 2.78913 2.65742C1.56317 3.88339 0.857043 5.53481 0.817658 7.26814C0.778274 9.00147 1.40866 10.6833 2.57768 11.9636C3.7467 13.244 5.36434 14.0244 7.0941 14.1425C8.82385 14.2606 10.5325 13.7072 11.8647 12.5976L16.4824 17.2153L17.347 16.3507ZM2.06069 7.43204C2.06069 6.34363 2.38344 5.27967 2.98812 4.3747C3.5928 3.46972 4.45227 2.76438 5.45782 2.34787C6.46337 1.93135 7.56985 1.82238 8.63734 2.03471C9.70483 2.24705 10.6854 2.77117 11.455 3.54078C12.2246 4.3104 12.7487 5.29095 12.9611 6.35844C13.1734 7.42593 13.0644 8.53241 12.6479 9.53797C12.2314 10.5435 11.5261 11.403 10.6211 12.0077C9.71611 12.6124 8.65215 12.9351 7.56375 12.9351C6.10474 12.9335 4.70596 12.3532 3.67428 11.3215C2.64261 10.2898 2.0623 8.89104 2.06069 7.43204Z"
                                    fill="black"
                                ></path>
                            </svg>
                            <input
                                type="text"
                                className='simpleFilter_input'
                                placeholder='Search'
                                value={filter.search}
                                onChange={(e) => setFilter((s) => ({ ...s, search: e.target.value }))}
                            />
                            {filter.search ? (
                                <span
                                    className="clear-icon"
                                    onClick={(e) => setFilter((s) => ({ ...s, search: '' }))}
                                >
                                    <RxCross2 size={20} color="black" />
                                </span>
                            ) : (
                                <></>
                            )}
                        </div>
                    </div> : <></>}

                    <button className='anime-btn _addComm_btn' onClick={billClick}>Raise Bill</button>
                </div>
            </div>
        </>
    )
}

export default TabWithFillter